import { Form, Modal, Switch } from "antd"
import { useState } from "react"

import { type AlbumCreateData } from "../../../../../../Album/types/album.types.ts"
import { TextArea } from "../../../../../../../components/Input/TextArea.tsx"
import { TextInput } from "../../../../../../../components/Input/TextInput.tsx"
interface CreateAlbumModalProps {
  onClose: () => void
  onSubmit?: (data: AlbumCreateData) => Promise<void>
}

export function CreateAlbumModal({ onClose, onSubmit }: CreateAlbumModalProps) {
  const [isLoading, setIsLoading] = useState(false)
  const [form] = Form.useForm<AlbumCreateData>()

  const handleClose = () => {
    onClose()
    form.resetFields()
  }

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields()
      setIsLoading(true)

      await onSubmit?.(values)

      handleClose()
    } catch (e) {
      console.error(e)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Modal
      title="Create New Album"
      open
      onCancel={handleClose}
      onOk={handleSubmit}
      okText="Create"
      cancelText="Cancel"
      confirmLoading={isLoading}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          is_visible_to_customer: false
          // order: 0
        }}
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please enter album name" }]}
        >
          <TextInput placeholder="Album name" maxLength={255} />
        </Form.Item>

        <Form.Item label="Description" name="description">
          <TextArea
            placeholder="Album description"
            rows={3}
            showCount
            maxLength={500}
          />
        </Form.Item>

        {/*<Form.Item label="Order" name="order">*/}
        {/*  <InputNumber min={0} className="w-full" />*/}
        {/*</Form.Item>*/}

        <Form.Item
          label="Visible to customer"
          name="is_visible_to_customer"
          valuePropName="checked"
        >
          <Switch />
        </Form.Item>
      </Form>
    </Modal>
  )
}
